import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Category from './pages/Category';
import OfferBridge from './pages/OfferBridge';
import OfferBridgePage from './pages/OfferBridgePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Support from './pages/Support';
import NotFound from './pages/NotFound';
import TopBar from './components/TopBar';
import BottomTabBar from './components/BottomTabBar';
import DesktopTabBar from './components/DesktopTabBar';
import ScrollToTop from './components/ScrollToTop';
import './styles/App.css';

const App = () => {
  return (
    <HashRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-black text-white pb-20">
        <TopBar />
        <DesktopTabBar />
        
        <main className="flex-grow pt-14 pl-0 md:pl-20 ">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:id" element={<Category />} />
            <Route path="/offer/:id" element={<OfferBridge />} />
            <Route path="/offer-bridge-page/" element={<OfferBridgePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/support" element={<Support />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <BottomTabBar />
      </div>
    </HashRouter>
  );
};

export default App;
